module.exports = __webpack_public_path__ + "static/media/address.5fb4dbcb.png";